module.exports = __webpack_public_path__ + "static/BB_Bourbon-34.536b4d5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BB_Bourbon-34.jpg
// module id = 446
// module chunks = 114276838955818